import { useQuery } from '@apollo/client'
import { useHistory } from 'react-router-dom'

import { USER_ROLES } from 'consts'
import { useAuth } from 'contexts/AuthContext'
import { useIsMobileDevice } from 'hooks'
import { UserStore } from 'stores'

import { GET_NEED_FOR_ONBOARDING_QUERY } from './query'

export default function BrandOnboardingHandler() {
  const userInfo = UserStore.userInfo

  const history = useHistory()
  const isMobileDevice = useIsMobileDevice()
  const { keycloak } = useAuth()

  const isAuthenticated = !!keycloak?.authenticated
  const isUserAllowed = userInfo?.role >= USER_ROLES.EDITOR

  useQuery(GET_NEED_FOR_ONBOARDING_QUERY, {
    skip: !isAuthenticated || !isUserAllowed || isMobileDevice,
    fetchPolicy: 'no-cache',
    onCompleted: data => {
      const isBrandSetupRequired = data?.getWorkspace?.isBrandSetupRequired
      const canUserSetup = data?.getWorkspace?.canUserSetup
      const shouldRedirect = isBrandSetupRequired && canUserSetup && !isMobileDevice && isUserAllowed

      if (shouldRedirect) {
        history.replace('/onboarding')
      }
    },
  })

  return null
}
